export const Company = (data) => ({
  id: data.id,
  source: data.attributes.source,
  sourceId: data.attributes.source_id,
  name: data.attributes.name,
  logoUrl: data.attributes.logo_url,
});

export const CompaniesList = (data) => data.map(Company);
